import React from 'react';
import PropTypes from 'prop-types';
import TEXT from '../../../assets/constants';
import GraphBG from '../../../assets/Images/graph_bg.svg';
import DynamicChart from './ChartRegion/dynamicChart';
import { DYNAMIC_GRAPH_IMAGES } from '../../../assets/constants.js';
import { EARLY_INTERVENTION_TEXTS } from './ChartRegion/helpers/graphConstants';
import useAnswers from '../../context/useAnswers';
import CONSTANTS from '../../../assets/constants';
import { getDialysisInfo } from '../../utils/dialysisModel/dialysisModel';
import { generatePdf } from '../../utils/pdfGenerator/pdfGenerator';

const Graphs = () => {
  const { answers, updateAnswers } = useAnswers();
  const egfrInitial = answers[CONSTANTS.REDUX.TREATMENT_TIMING]?.value;
  const age = answers[CONSTANTS.REDUX.INITIAL_AGE]?.value;
  const treatment = answers[CONSTANTS.REDUX.TREATMENT_PLAN]?.value;
  const risk = answers[CONSTANTS.REDUX.RISK]?.value;
  const earlyInterventionText = EARLY_INTERVENTION_TEXTS[treatment] || '';
  const dialysisInfo = getDialysisInfo(risk, treatment, age, egfrInitial);
  const yearsGained =
    dialysisInfo.timeToDialysisTreatment -
    dialysisInfo.timeToDialysisNoTreatment;
  const riskReduction = dialysisInfo.riskReduction;
  const heartFailureRate = dialysisInfo.heartFailureRate;
  const nominalHeartFailureRate = dialysisInfo.nominalHeartFailureRate;

  const handleDownload = async () => {
    const chartElement = document.querySelector('.chart-container');
    if (!chartElement) {
      return;
    }
    await generatePdf(chartElement, dialysisInfo.footnoteStrings);
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${GraphBG})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          padding: '0.5rem',
        }}
      >
        <div className="grid-container full">
          <div className="graph-layout-container">
            <div className="graph-header">{TEXT.GRAPH_HEADER}</div>
            <div className="chart-container">
              <DynamicChart
                alt={TEXT.GRAPH_ALT}
                egfrInitial={egfrInitial}
                age={age}
                treatment={treatment}
                risk={risk}
              />
            </div>
            <div className="egfr-slider-container">
              <div className="slider-wrapper-responsive">
                <label htmlFor="egfrSlider" className="slider-label">
                  {TEXT.INITIAL_EGFR_SLIDER_LABEL} {egfrInitial}
                </label>
                <div className="slider-with-labels">
                  <span className="slider-min-label">15</span>
                  <input
                    type="range"
                    id="egfrSlider"
                    min="15"
                    max="120"
                    value={egfrInitial}
                    onChange={(e) =>
                      updateAnswers({
                        [CONSTANTS.REDUX.TREATMENT_TIMING]: {
                          value: Number(e.target.value),
                          answered: true,
                        },
                      })
                    }
                    className="slider slider-wide"
                  />
                  <span className="slider-max-label">120</span>
                </div>
              </div>
            </div>
            <div className="results-footer upper-results-footer">
              <img
                className="results-image"
                src={DYNAMIC_GRAPH_IMAGES.UPPER_RESULTS_REGION}
                alt={TEXT.RESULTS_SUMMARY_DIALYSIS_ALT}
              />
              <div className="upper-results-overlay">
                <span className="years-value">~{yearsGained}</span>
              </div>
              {earlyInterventionText && (
                <div className="upper-intervention-overlay">
                  <span className="intervention-text">
                    {earlyInterventionText}
                  </span>
                </div>
              )}
            </div>
            <div className="results-footer lower-results-footer">
              <img
                className="results-image"
                style={{ marginTop: -1 }}
                src={DYNAMIC_GRAPH_IMAGES.LOWER_RESULTS_REGION}
                alt={TEXT.RESULTS_SUMMARY_HEART_FAILURE_ALT}
              />
              <div className="lower-results-overlay">
                <span className="without-value">{nominalHeartFailureRate}</span>
                <span className="with-value">{heartFailureRate}</span>
                <span className="risk-value">{riskReduction}%</span>
              </div>
            </div>
            <div className="grid-x align-center">
              <button
                className="button secondary margin-3"
                onClick={() => handleDownload()}
                type="button"
              >
                {TEXT.PRINT_BUTTON_TEXT}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Graphs.propTypes = {
  result: PropTypes.number,
};

export default Graphs;
